/**
 * Support Domain — Public API (Barrel Export)
 *
 * All support/explanation content resolution, hints, and coverage reporting.
 * External consumers should import from this barrel only.
 */

// Types
export type {
  ExplanationContent,
  ResolvedSupport,
  SupportCoverage,
} from './types'
export { calculateCoverage } from './types'

// Hint types
export type { HintStep, HintVisual, HintType } from './hints'

// Support resolver
export { resolveSupportContent, resolveUnifiedSupport } from './supportResolver'
export type { QuestionResolvedSupport } from './supportResolver'

// Family support registry
export {
  FAMILY_SUPPORT_REGISTRY,
  getFamilySupportEntry,
  getHintsForFamilyId,
  getAllSupportedFamilyIds,
} from './familySupportRegistry'
export type {
  FamilySupportEntry,
  RepresentationSupport,
} from './familySupportRegistry'

// Coverage reporting
export {
  generateSupportCoverageReport,
  assertSupportCoverage,
  validateHintQuality,
} from './supportCoverageReport'
export type {
  SupportCoverageReport,
  FamilyCoverageStatus,
  HintQualityReport,
  HintQualityIssue,
} from './supportCoverageReport'

// UI components (moved here in RC Ronde 5 — S-3).
// These render support-domain data; co-located in support/components/.
export { CheatSheetDrawer } from './components/CheatSheetDrawer'
export { SubSkillCheatSheet } from './components/SubSkillCheatSheet'
export { UniversalStrategyCard } from './components/UniversalStrategyCard'
